import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../services/helpers.service';

@Component({ standalone: false,
  selector: 'vfa-cp-contract-selection-form',
  templateUrl: './contract-selection-form.component.html',
  styleUrls: ['./contract-selection-form.component.scss']
})
export class ContractSelectionFormComponent implements OnChanges {

  @Input() isOnboarding!: boolean;
  @Input() order: any;
  @Input() descLabel: any;
  @Input() durations: any;
  @Input() years: any;
  @Output() onSelectedContract: EventEmitter<any> = new EventEmitter();

  public request: any = null;
  public order_id = '';
  public wait: boolean = true;
  public waitSave: boolean = false;
  public contractSelectionForm!: FormGroup;

  public ONBOARDING_AUTORENEWAL_FOR_DURATIONS: any = null;

  constructor(private formBuilder: FormBuilder, private helpersService: HelpersService) {
    this.ONBOARDING_AUTORENEWAL_FOR_DURATIONS = this.helpersService.config?.ONBOARDING_AUTORENEWAL_FOR_DURATIONS || 36;
  }

  ngOnChanges(changes: any) {
    if (changes) {
      this.createForm(this.durations);
    }
  }

  private createForm(req: any) {
    if(req.orders.length === 1){
      req.contract_duration = req.orders[0];
    }
    this.request = req;
    this.request.automatic_renewal = this.isOnboarding && this.order.is_automatic_renewal_available ? true : false;
    this.contractSelectionForm = this.formBuilder.group({
      contract_duration: new FormControl(this.request.contract_duration, [Validators.required]),
      automatic_renewal: new FormControl({value: this.request.automatic_renewal, disabled: false}),
    })
  }

  contractSelection() {
    this.waitSave = true;
    this.onSelectedContract.emit(this.request);
  }
}
